import type { MeshConfig } from '../core/types.js'

export function defineMeshConfig(config: MeshConfig): MeshConfig {
  return config
}
